// momentLocale.js

import moment from "moment";

// French
moment.updateLocale("fr", {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
});

// Italian
moment.updateLocale("it", {
  week: {
    dow: 1, // Monday is the first day of the week.
  },
});

export default moment;
